import { createContext, use } from "react";

// ------------------------------- CONSTANTS -------------------------------
export const PwaInstallContext = createContext<PwaInstallContextValue | undefined>(undefined);

// --------------------------------- TYPES ---------------------------------
export type PwaInstallChoice = {
	readonly outcome: "accepted" | "dismissed";
	readonly platform: string;
};

export interface PwaInstallPromptEvent extends Event {
	readonly userChoice: Promise<PwaInstallChoice>;
	prompt(): Promise<PwaInstallChoice>;
}

declare global {
	interface WindowEventMap {
		beforeinstallprompt: PwaInstallPromptEvent;
	}
}

type PwaInstallContextValue = {
	readonly podeInstalar: boolean;
	readonly instalando: boolean;
	readonly aoInstalar: () => Promise<void>;
};

// ------------------------------- FUNCTIONS -------------------------------
export function usePwaInstall() {
	const contexto = use(PwaInstallContext);
	if (!contexto) throw new Error("usePwaInstall deve ser usado dentro de PwaInstallProvider.");
	return contexto;
}
